import React from "react";
import { ReactComponent as CloseIcon } from "assets/close.svg";
import { StyledFloatingCloseButton } from "./styled";

function FloatingCloseButton({
  ariaLabel = "Close",
  className = "",
  iconSize = 16,
  onClick,
  type = "button",
}) {
  return (
    <StyledFloatingCloseButton
      aria-label={ariaLabel}
      className={className}
      iconSize={iconSize}
      onClick={onClick}
      type={type}
    >
      <CloseIcon />
    </StyledFloatingCloseButton>
  );
}

export default FloatingCloseButton;
